
interface ButtonProps {
    text: string;
    color: string;
    textColor?: string;
    onClick?: () => void;
    disabled?: boolean;
}

const GeneralButton: React.FC<ButtonProps> = ({ text, color, textColor, onClick, disabled }) => {
    return (
        <button 
            onClick={onClick} 
            disabled={disabled}
            className="mt-5 mb-10 w-full max-w-sm font-extrabold py-4 rounded-full text-lg" 
            style={{ 
                backgroundColor: color, 
                cursor: disabled ? 'not-allowed' : 'pointer',
                color: textColor ?? 'black',
                opacity: disabled ? 0.6 : 1
            }}
        >
            {text}
        </button>
    );
};

export default GeneralButton;